import { useEffect, useState } from 'react';
import { getChatMessages, getAIResponseForSession } from '../utils/firebaseService';
import useLimits from '../hooks/useLimits';

export default function useChat({ contentId, user }) {
  const [chatMessages, setChatMessages] = useState([]);
  const [chatInput, setChatInput] = useState('');
  const [isAILoading, setIsAILoading] = useState(false);

  // ✅ Limits hook
  const { chat: chatLimit } = useLimits();

  // Subscribe to messages
  useEffect(() => {
    if (!contentId || !user) return;
    const unsubscribe = getChatMessages(contentId, (messages) => {
      setChatMessages(messages);
    });
    return () => { if (unsubscribe) unsubscribe(); };
  }, [contentId, user]);

  const handleChatSubmit = async (e, selectedModel = 'Gemini 2.5 Flash') => {
    e?.preventDefault?.();
    if (!chatInput.trim() || !contentId || !user) return;

    // ✅ Check before sending
    if (chatLimit <= 0) {
      alert("You’ve reached today’s chat limit. Upgrade to unlock more.");
      return;
    }

    const messageText = chatInput.trim();
    setChatInput('');
    setIsAILoading(true);

    try {
      // Pass the selectedModel to getAIResponseForSession
      await getAIResponseForSession(contentId, messageText, selectedModel);


      // Removed decrementLimit call as backend handles it
    } catch (error) {
      console.error("Error in chat:", error);
      // No local save to avoid duplication; UI will reflect backend state.
    } finally {
      setIsAILoading(false);
    }
  };

  return { chatMessages, chatInput, setChatInput, handleChatSubmit, isAILoading };
}